const backendUrl = ((window.location.hostname).includes('localhost') || (window.location.hostname).includes('test')) ? "https://kulwm9pjrf.execute-api.eu-central-1.amazonaws.com/test/api/secrets" : "https://saro9gqaod.execute-api.eu-central-1.amazonaws.com/prod/api/secrets";
module.exports = {
    backendUrl
}